/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Players_Print_StandingsInputs */



/**
* | output |
* | --- |
* | "Print standings" |
*
* @param {Players_Print_StandingsInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const players_print_standings = /** @type {((inputs?: Players_Print_StandingsInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Players_Print_StandingsInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Imprimer le classement")
	if (locale === "es") return /** @type {LocalizedString} */ ("Imprimir la clasificación")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Imprimir classificação")
	if (locale === "it") return /** @type {LocalizedString} */ ("Stampa la classifica")
	return /** @type {LocalizedString} */ ("Print standings")
});